import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2b187c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "pagination pagination-list" }
const _hoisted_5 = {
  key: 0,
  class: "page-link"
}
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_ctx.total === 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0"))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, "แสดง " + _toDisplayString(_ctx.start) + " ถึง " + _toDisplayString(_ctx.end) + " จากจำนวนทั้งหมด " + _toDisplayString(_ctx.total), 1)),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", {'disabled': _ctx.currentPage === 1}])
      }, [
        _createElementVNode("button", {
          class: "page-link navigation-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousClick && _ctx.previousClick(...args)))
        }, "ก่อนหน้า")
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageList, (page) => {
        return (_openBlock(), _createElementBlock("li", {
          key: page,
          class: _normalizeClass(["page-item d-none d-sm-block", {'active': _ctx.currentPage === page}])
        }, [
          (_ctx.currentPage === page)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(page), 1))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "page-link",
                onClick: ($event: any) => (_ctx.pageClick(page))
              }, _toDisplayString(page), 9, _hoisted_6))
        ], 2))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", {'disabled': _ctx.currentPage >= _ctx.maxPage}])
      }, [
        _createElementVNode("button", {
          class: "page-link navigation-link",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextClick && _ctx.nextClick(...args)))
        }, "ถัดไป")
      ], 2)
    ])
  ]))
}